// Rumbo: la llave de repuesto del cofre (24 caracteres en grupos de 4).
// Sin 0/O, 1/I/L ni U para que no haya dudas al copiarla a mano (Crockford).
const ALFABETO_REPUESTO = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const LARGO_REPUESTO = 24;

export function crearLlaveRepuesto(): string {
  const azar = crypto.getRandomValues(new Uint8Array(LARGO_REPUESTO));
  // 256 es múltiplo de 32: cada carácter sale igual de probable.
  return Array.from(azar, b => ALFABETO_REPUESTO[b & 31]).join('');
}

// Admite la llave escrita a mano: da igual mayúsculas, espacios o guiones, y
// O/I/L se leen como 0/1/1.
export function normalizarLlaveRepuesto(escrita: string): string | null {
  const limpia = escrita
    .toUpperCase()
    .replace(/[\s-]/g, '')
    .replace(/O/g, '0')
    .replace(/[IL]/g, '1');
  if (limpia.length !== LARGO_REPUESTO) {
    return null;
  }
  for (const c of limpia) {
    if (!ALFABETO_REPUESTO.includes(c)) {
      return null;
    }
  }
  return limpia;
}

export function formatearLlaveRepuesto(llave: string): string {
  return llave.match(/.{1,4}/g)?.join(' ') ?? llave;
}
